const initialState = {
    loading: false,
    channels: [],
    error: null,
    saving: false,
    selectedChannel: null,
  };
  
  const channelsReducer = (state = initialState, action) => {
    switch (action.type) {
      case "FETCH_CHANNELS_REQUEST":
        return { ...state, loading: true, error: null };
  
      case "FETCH_CHANNELS_SUCCESS":
        return { ...state, loading: false, channels: action.payload || [] };
  
      case "FETCH_CHANNELS_FAILURE":
        return { ...state, loading: false, error: action.payload };
  
      case "SAVE_CHANNEL_SUCCESS":
        return {
          ...state,
          channels: [...(state.channels || []), ...(action.payload || [])],
        };
  
      case "DELETE_CHANNEL_SUCCESS":
        return {
          ...state,
          channels: state.channels.filter((c) => c._id !== action.payload._id),
        };
  
      case "UPDATE_CHANNEL_SUCCESS":
        return {
          ...state,
          channels: state.channels.map((c) =>
            c._id === action.payload._id ? action.payload : c
          ),
        };
  
      case "FETCH_CHANNEL_BY_ID_SUCCESS":
        return { ...state, selectedChannel: action.payload };
  
      default:
        return state;
    }
  };
  
  export default channelsReducer;
  